module.exports = __webpack_public_path__ + "static/media/img_references_optimized.0678a078.jpg";